import * as d3 from "d3";
import {
    axisTextDim1,
    colonAnnotation, contextMenu, createTooltip,
    DEFAULT_AXIS_FONT_SIZE,
    DEFAULT_AXIS_LABEL_FONT_SIZE,
    format,
    fw_progressive_1way,
    fw_progressive_3way, generateDownloadData,
    inrFormatterV2,
    make_y_gridlines,
    responsivefy,
    XaxisAttribute
} from '../functions'

export default function (chart, divId, vizName, resData,filterParam, gridflag) {
    const defaultSize = true
    const defaultChartLayout = {
        width: 1000,
        height: 400,
        margin: { top: 20, right: 180, bottom: 100, left: 80 }
    }
    const chartWidth = defaultSize ? defaultChartLayout.width : chart.width
    const chartHeight = defaultSize ? defaultChartLayout.height : chart.height
    const chartMargin = defaultSize ? defaultChartLayout.margin : chart.margin

    const axisTickFontPx = defaultSize ? DEFAULT_AXIS_FONT_SIZE : chart.axisFontSize
    var axisfontsize = axisTickFontPx + "px"
    var axisfontcolor = chart.axisFontColor
    var axislabelfontcolor = chart.axisLabelFontColor
    //var tempVar = chart.tempVar
    var axisLabelFontSize = (defaultSize ? DEFAULT_AXIS_LABEL_FONT_SIZE : chart.axisLabelFontSize) + "px"


    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName


    function DataSegregator(array, on) {
        let OrdinalPositionHolder;
        OrdinalPositionHolder = {
            valueOf: function () {
                let thisObject;
                thisObject = this
                var keys = Object.keys(thisObject)
                keys.splice(keys.indexOf('valueOf'), 1)
                keys.splice(keys.indexOf('keys'), 1)
                return keys.length === 0 ? -1 : d3.max(keys, function (d) {
                    return thisObject[d]
                })
            },
            keys: function () {
                let thisObject;
                thisObject = this
                var keys = Object.keys(thisObject)
                keys.splice(keys.indexOf('valueOf'), 1)
                keys.splice(keys.indexOf('keys'), 1)
                return keys
            }
        }
        array[0].map(function (d) {
            return d[on]
        }).forEach(function (b) {
            var value = OrdinalPositionHolder.valueOf()
            OrdinalPositionHolder[b] = OrdinalPositionHolder > -1 ? ++value : 0
        })
        var SegData = OrdinalPositionHolder.keys().map(function () {
            return []
        })

        // draw Line
        array.forEach(function (d) {
            d.forEach(function (b) {
                SegData[OrdinalPositionHolder[b[on]]].push(b)
            })
        })
        return SegData
    }

    console.warn('format', format)
    // axios.post(url, filterParam).then(response => {
        let Data = resData
        // Adding salesman in Line Category
        Data.forEach(function (d) {
            d.metric.forEach(function (b) {
                b.dim1 = d.dim1
            })
        })

        // Extension method declaration
        var dim2 = []
        dim2.pro
        var LineCategories = []
        LineCategories.pro

        var x1Scale = d3.scaleBand().rangeRound([0, chartWidth]).paddingInner(.2)
        var x2Scale = d3.scaleBand()
        var y1Scale = d3.scaleLinear().range([chartHeight, 0])

        var y2Scale = d3.scaleLinear().range([chartHeight, 0])
            .domain(d3.extent(Data, function (d) {
                return d3.max(d.metric, function (b) {
                    return b.Value
                })
            }))
        var metric1ColorScale = d3.scaleOrdinal().range(fw_progressive_1way)
        // domain is set after dim2 is sorted below

        var line = d3.line()
            .x((d) => {
                return x1Scale(d.dim1) + x1Scale.bandwidth() / 2
            })
            .y((d) => {
                return y2Scale(d.Value)
            })

        var x1AxisLabel = d3.axisBottom().scale(x1Scale)
        var y1AxisLabel = d3.axisLeft().scale(y1Scale).tickFormat(function (d){return inrFormatterV2(d,chart.data.menuId)})
        var y2AxisLabel = d3.axisRight().scale(y2Scale).tickFormat(function (d){return inrFormatterV2(d,chart.data.menuId)})

        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append('svg')
            .attr('width', chartWidth + chartMargin.left + chartMargin.right)
            .attr('height', chartHeight +  chartMargin.top + chartMargin.bottom)
            .call(responsivefy)
            .append('g')
            .attr('transform', 'translate(' + chartMargin.left + ',' + chartMargin.top + ')')

        // Bar Data categories
        Data.sort((a, b) => a.dim1.localeCompare(b.dim1))

        Data.forEach(function (d) {
            d.dim2.forEach(function (b) {
                if (dim2.findIndex(function (c) {
                    return c.Name === b.Name
                }) === -1) {
                    b.Type = 'bar'
                    dim2.push(b)
                }
            })
        })
        dim2.sort((a, b) => a.Name.localeCompare(b.Name))
        Data.forEach(d => d.dim2.sort((a, b) => a.Name.localeCompare(b.Name)))
        metric1ColorScale.domain(dim2.map(d => d.Name))

        // Line Data dim2
        Data.forEach(function (d) {
            d.metric.forEach(function (b) {
                if (LineCategories.findIndex(function (c) {
                    return c.Name === b.Name
                }) === -1) {
                    b.Type = 'line'
                    LineCategories.push(b)
                }
            })
        })
        LineCategories.sort((a, b) => a.Name.localeCompare(b.Name))

        // Processing Line data
        let lineData;
        lineData = DataSegregator(Data.map(function (d) {
            return d.metric
        }), 'Name')

        // Line Coloring
        let metric2ColorScale = d3.scaleOrdinal()
        metric2ColorScale.domain(LineCategories.filter(function (d) {
            return d.Type === 'line'
        })
            .map(function (d) {
                return d.Name
            }))

        metric2ColorScale.range(fw_progressive_3way)

        x1Scale.domain(Data.map(function (d) {
            return d.dim1
        }))
        x1Scale.domain(Data.map(function (d) {
            return d.dim1
        }))
        x2Scale.domain(dim2.filter(function (d) {
            return d.Type === 'bar'
        })
            .map(function (d) {
                return d.Name
            }))
            .rangeRound([0, x1Scale.bandwidth()])

        y1Scale.domain([0, d3.max(Data, function (d) {
            return d3.max(d.dim2, function (d) {
                return d.Value
            })
        })])

        svg.append('g')
            .attr('class', 'x axis')
            .attr('transform', 'translate(0,' + chartHeight + ')')
            .call(x1AxisLabel)
            .selectAll('text')
            .style('font-size', axisfontsize)
            .style('fill', axisfontcolor)
            .style('text-anchor', 'start')
            .attr('dx', XaxisAttribute)
            .attr('dy', '-0.55em')
            .attr('transform', 'rotate(-50)')
            .text(axisTextDim1)

        svg.append('g')
            .attr('class', 'y axis')
            .call(y1AxisLabel)
            .selectAll('text')
            .style('font-size', axisfontsize)
            .style('fill', axisfontcolor)

        svg.append('g')
            .attr('class', 'y axis')
            .attr('transform', 'translate(' + (chartWidth) + ',0)')
            .call(y2AxisLabel)
            .selectAll('text')
            .style('font-size', axisfontsize)
            .style('fill', axisfontcolor)

        svg.append('text')
            .attr('x', (chartWidth / 2))
            .attr('y', chartHeight + chartMargin.bottom - 30 )
            .style('fill', axisfontcolor)
            .style('text-anchor', 'middle')
            .text(chart.x1AxisDisplayName)
            .style('font-size', axisLabelFontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('x', 0 - (chartHeight / 2))
            .attr('y', 0 - chartMargin.left + 10)
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', axislabelfontcolor)
            .text(chart.y1AxisDisplayName)
            .style('font-size', axisLabelFontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('x', 0 - (chartHeight / 2))
            .attr('y', chartWidth + chartMargin.right - 130)
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', axislabelfontcolor)
            .text(chart.y2AxisDisplayName)
            .style('font-size', axisLabelFontSize)


        if (gridflag == true) {
            // add the X gridlines
            /* svg.append("g")
                             .attr("class", "grid")
                             .attr("transform", "translate(0," + chart.height + ")")
                             .call(make_x_gridlines(x1Scale)
                                .tickSize(-chart.height)
                                .tickFormat("") )*/

            // add the Y gridlines
            svg.append("g")
                .attr("class", "grid")
                .call(make_y_gridlines(y1Scale)
                    .tickSize(-chartWidth)
                    .tickFormat(""))
        }

        /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element
                           var y1tip = tooltip_class()

                           y1tip.attr('class', 'd3-tip'+divId.id)
                               .html(function (d) {
                                   return d.Name.replace(/(\d{4})/g, '$1-').trim()+ colonAnnotation+ numberFormat(d.Value)
                               })
                           svg.call(y1tip)*/

        // d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        // var div = d3.select(divId).append('div').attr('class', 'tooltip')
        //     .attr('style', 'position: absolute; opacity: 0;')
    const tooltip = createTooltip(divId);

        var state = svg.selectAll('.state')
            .data(Data)
            .enter().append('g')
            .attr('class', 'state')
            .attr('transform', (d) => {
                return 'translate(' + x1Scale(d.dim1) + ',0)'
            })

        state.selectAll('rect')
            .data((d) => {
                return d.dim2
            })
            .enter().append('rect')
            .attr('width', x2Scale.bandwidth())
            .attr('x', (d) => {
                return x2Scale(d.Name)
            })
            .attr('y', (d) => {
                return y1Scale(d.Value)
            })
            .style('fill', (d) => {
                return metric1ColorScale(d.Name)
            })
            .on('mouseover', function(event, d) {

                tooltip.onMouseOver(d, this, function(d) {
                    // Tooltip content callback
                    return d.Name.replace(/(\d{4})/g, '$1-').trim() + colonAnnotation + inrFormatterV2(d.Value,chart.data.menuId)
                });  // Pass the event for positioning
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on('mouseout', function() {
                tooltip.onMouseLeave();  // Hide the tooltip on mouse leave
            })
            .on('contextmenu', function(event, d) {
                const parentData = d3.select(this.parentNode).datum();
                console.log("paran",d);
                // Prepare clickedData with both axes' info
                const clickedData = {
                    [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [parentData.dim1],               // e.g., "metric1"
                    [chart.insightNavigator.realDataFieldNames.x2RealDataFieldName]:[d.Name]
                };
                console.log("clickedData",clickedData);
                // Generate the menu with current config and filters
                const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                // Show the context menu
                contextMenu(menuItems).call(this, clickedData);

                // Prevent default context menu
                event.preventDefault();
            })
            .transition().delay(200)
            .attrTween('height', function (d) {
                var i = d3.interpolate(0, chartHeight - y1Scale(d.Value))
                return function (t) {
                    return i(t)
                }
            })

        // drawaing lines
        svg.selectAll('.lines')
            .data(lineData)
            .enter()
            .append('g')
            .attr('class', 'line')
            .each(function (d) {
                let Name;
                Name = d[0].Name
                d3.select(this)
                    .append('path')
                    .attr('d', function (b) {
                        return line(b)
                    })
                    .style('stroke-width', '3px')
                    .style('fill', 'none')
                    .style('stroke', metric2ColorScale(Name))
                    .transition()
                    .duration(1500)
            })

        svg.selectAll("dot")
            .data(Data, function (d) {
                return d.metric
            })
            .enter()
            .append("circle")
            .attr("r", 5)
            .attr("cx", function (d) {
                return x1Scale(d.dim1) + x1Scale.bandwidth() / 2
            })
            .attr("cy", function (d) {
                return y2Scale(d.metric[0].Value);
            })
            .style("fill", function (d) {
                return metric2ColorScale(d.metric[0].Name)
            })
            .on('mouseover', function(event, d) {

                tooltip.onMouseOver(d, this, function(d) {
                    // Tooltip content callback
                    return chart.x1MetricTooltip + colonAnnotation + d.dim1 + "<br/>" +
                        d.metric[0].Name + colonAnnotation + inrFormatterV2(d.metric[0].Value,chart.data.menuId)
                });  // Pass the event for positioning
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on('mouseout', function() {
                tooltip.onMouseLeave();  // Hide the tooltip on mouse leave
            })
            .on('contextmenu', function(event, d) {
                console.log(d)
                // Prepare clickedData with both axes' info
                const clickedData = {
                    [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [d.dim1],               // e.g., "metric1"
                };
                console.log("clickedData",clickedData);
                // Generate the menu with current config and filters
                const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                // Show the context menu
                contextMenu(menuItems).call(this, clickedData);

                // Prevent default context menu
                event.preventDefault();
            });

        console.log("cumlative bar", Data)
        const legendItems = [
            ...dim2.map((d) => ({ Name: d.Name, Type: 'bar' })),
            ...LineCategories.map((d) => ({ Name: d.Name, Type: 'line' }))
        ]

        var y1legend = svg.selectAll(".legend")
            .data(legendItems)
            .enter()
            .append("g")
            .attr('class', 'legend')
            .attr('transform', function (d, i) {
                var horz = chartWidth + chartMargin.left + 10;
                var vert = i * 17;
                return 'translate(' + horz + ',' + vert + ')';
            });

        y1legend.append('circle')
            .attr('cx', 0)
            .attr('cy', 30)
            .attr("r", 5)
            .style('fill', function (d) {
                return d.Type === 'line' ? metric2ColorScale(d.Name) : metric1ColorScale(d.Name);
            });

        y1legend.append('text')
            .attr('x', 10)
            .attr('y', 35)
            .style('font-size', axisfontsize)
            .style('fill', axisfontcolor)
            .text(function (d) {
                const label = (d.Name || '').replace(/(\d{4})/g, '$1-').trim();
                return label.length > 10 ? label.substring(0, 10) + "..." : label;
            });
    // })
}
